module.exports = __webpack_public_path__ + "assets/img/4891-tj.svg";